import { activateSiteDisabled403 } from "@/store/zustand/siteDisabledStore";

function collectBodyStrings(body: unknown): string[] {
  const out: string[] = [];
  if (body == null) return out;
  if (typeof body === "string") {
    out.push(body);
    return out;
  }
  if (typeof body !== "object") return out;
  const o = body as Record<string, unknown>;
  const push = (v: unknown) => {
    if (typeof v === "string") out.push(v);
  };
  push(o.detail);
  push(o.message);
  push(o.title);
  push(o.error_message);
  const err = o.error;
  if (err && typeof err === "object") {
    push((err as Record<string, unknown>).message);
  }
  return out;
}

/** True when HTTP 403 represents “site disabled” (status text or JSON body). */
export function isSiteDisabled403Payload(
  httpStatus: number,
  statusText?: string | null,
  body?: unknown
): boolean {
  if (httpStatus !== 403) return false;

  const text = `${statusText ?? ""}`.toLowerCase();
  if (text.includes("site disabled")) return true;
  if (text.includes("site_disabled")) return true;

  const joined = collectBodyStrings(body).join(" ").toLowerCase();
  if (joined.includes("site disabled")) return true;
  if (joined.includes("site_disabled")) return true;
  if (joined.includes("site has been disabled")) return true;

  return false;
}

/** Activates the full-page overlay when the response indicates 403 Site Disabled. */
export function tryActivateSiteDisabled403(
  httpStatus: number,
  statusText?: string | null,
  body?: unknown
): boolean {
  if (!isSiteDisabled403Payload(httpStatus, statusText, body)) return false;
  activateSiteDisabled403();
  return true;
}
